import React, { useCallback, useState } from "react";
import { useSearchParams } from "react-router-dom";
import TemplateList from "./TemplateList";
import CreateTemplate from "./CreateTemplate";
import TemplateDetail from "./TemplateDetail";
import SendTemplate from "./SendTemplate";

const VIEWS = ["list", "create", "detail", "send"];

const RcsTemplate = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [agentMissing, setAgentMissing] = useState(false);

  const rawView = searchParams.get("view");
  const view = VIEWS.includes(rawView) ? rawView : "list";
  const id = searchParams.get("id");

  const nav = {
    list: (filters = {}) => setSearchParams(filters),
    create: (fromId) => setSearchParams(fromId ? { view: "create", from: fromId } : { view: "create" }),
    detail: (templateId) => setSearchParams({ view: "detail", id: String(templateId) }),
    send: (templateId) => setSearchParams({ view: "send", id: String(templateId) }),
  };

  const onAgentMissing = useCallback(() => setAgentMissing(true), []);

  if (agentMissing) {
    return (
      <div className="p-6 bg-[#f8fafc] font-sans text-left min-h-[calc(93vh_-_50px)] flex items-center justify-center">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-10 max-w-md text-center">
          <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-[#00b6ce]/10 flex items-center justify-center text-[#00b6ce] text-2xl font-bold">
            !
          </div>
          <h2 className="text-lg font-bold text-gray-800 mb-2">RCS is not enabled</h2>
          <p className="text-sm text-gray-500">
            RCS is not enabled for your account. Contact support.
          </p>
        </div>
      </div>
    );
  }

  const common = { nav, onAgentMissing };

  return (
    <div className="p-6 bg-[#f8fafc] font-sans text-left relative min-h-[calc(93vh_-_50px)]">
      {view === "list" && <TemplateList {...common} searchParams={searchParams} />}
      {view === "create" && <CreateTemplate {...common} fromId={searchParams.get("from")} />}
      {view === "detail" && <TemplateDetail key={id} {...common} id={id} />}
      {view === "send" && <SendTemplate key={id} {...common} id={id} />}
    </div>
  );
};

export default RcsTemplate;
